
<div class="card">
  <div class="card-header">
    <h4>Subir Archivo</h4>
    
  </div>
  <div class="card-body">
    
    <div class="row">
      <div class="col-8">
        <label class="btn btn-default p-0">
          <input type="file" (change)="selectFile($event)" accept=".pdf" />
        </label>

        <div *ngIf="validPdf" class="pdf-container">
      
          <pdf-viewer [src]="pdfContent"
            [rotation]="0"
            [original-size]="false"
            [show-all]="true"
            [fit-to-page]="true"
            [zoom]="1"
            [zoom-scale]="'page-width'"
            [stick-to-page]="false"
            [render-text]="true"
            [external-link-target]="'blank'"
            [autoresize]="true"
            [show-borders]="false"
            style="width: 100%; height: 100vh;"
          ></pdf-viewer>

        </div>   

      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <button class="btn btn-success btn-sm" [disabled]="!selectedFiles" (click)="upload()">
          Subir
        </button>
      </div>
    </div>
    
    <div class="row"> 
    <div *ngIf="currentFile" class="progress my-3">
      <div
        class="progress-bar progress-bar-info progress-bar-striped"
        role="progressbar"
        attr.aria-valuenow="{{ progress }}"
        aria-valuemin="0"
        aria-valuemax="100"
        [ngStyle]="{ width: progress + '%' }"
      >
        {{ progress }}%
      </div>
    </div>
    
    <div *ngIf="message" class="alert alert-secondary" role="alert">{{ message }}</div>
    </div> 

  </div>
</div>




<!-- <div class="row">
  <div class="card mt-3">
    <div class="card-header">Lista de Archivos(Persona Fisica)</div>
    <ul
      class="list-group list-group-flush"
      *ngFor="let file of fileInfos | async"
    >
      <li class="list-group-item">
        <a href="{{ file.url }}">{{ file.name }}</a>
      </li>
    </ul>
  </div>
</div> -->

<div class="row">
  <div class="card">
    <div class="card-header"><h2 class="text-center">Mis Archivos - (Persona Fisica).</h2> </div>
    <div class="card-body">
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col"></th>
          <th scope="col">Archivo</th>
          <th scope="col">Fecha de Carga</th>
          <th scope="col"></th>
          <!-- <th scope="col">Area</th>
          <th scope="col">Population</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let file of fileInfos | async; index as i">
          <th scope="row">{{ i + 1 }}</th>
          <!-- <td>
            <img
              [src]="'https://upload.wikimedia.org/wikipedia/commons/' + country.flag"
              class="me-2"
              style="width: 20px"
            />
            {{ country.name }}
          </td>
          <td>{{ country.area | number }}</td>
          <td>{{ country.population | number }}</td> -->
          <td>
            <span (click)="downloadFile(file.nameId, file.name)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16">
                <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293z"/>
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
              </svg>
            </span>
          </td>
          <td>
            <p>{{ file.name }}</p>
          </td>
          <td>
            {{ file.created_at }}
          </td>
          <td>
            <span (click)="deleteFile(file.nameId)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
              </svg>
            </span>
          </td>

        </tr>
      </tbody>
    </table>    
  </div>
  </div>
</div>

